// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.month-picker .ui-button-text {\n  padding: .4em 0;\n  font-size: 12.6px;\n}\n", ""]);
// Exports
module.exports = exports;
